export default __webpack_public_path__ + "static/media/todo-app.589bf466.png";